/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Title_AccentInputs */

const en_gc_home_title_accent = /** @type {(inputs: Gc_Home_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clarity, cell by cell.`)
};

const zh_gc_home_title_accent = /** @type {(inputs: Gc_Home_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从单元格，看清每一个想法。`)
};

/**
* | output |
* | --- |
* | "Clarity, cell by cell." |
*
* @param {Gc_Home_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_title_accent = /** @type {((inputs?: Gc_Home_Title_AccentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Title_AccentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_title_accent(inputs)
	return zh_gc_home_title_accent(inputs)
});
export { gc_home_title_accent as "gc.home.title_accent" }